'use client';

import { SurveyErrorPage } from '../components/SurveyErrorPage';

export default function Error() {
  return (
    <SurveyErrorPage
      statusCode="500"
      title="Something Went Wrong"
      message="We could not complete this survey action. Please go back and try again."
    />
  );
}
